var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "pb-0": "" } },
    [
      _c(
        "v-row",
        {
          attrs: {
            align: "center",
            justify: "center",
            dense: "",
            "no-gutters": "",
            "align-content": "center"
          }
        },
        [
          _c("v-col", { attrs: { cols: "2", "align-self": "center" } }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldBackDisplay,
                  expression: "shouldBackDisplay"
                }
              ],
              staticClass: "backButton",
              attrs: { left: "", src: "/static/back.png", id: "back" },
              on: { click: _vm.goBack }
            })
          ]),
          _vm._v(" "),
          _c("v-col", { attrs: { cols: "8", "align-self": "center" } }, [
            _c(
              "div",
              { staticClass: "logoWrapper", attrs: { align: "center" } },
              [
                _c("v-img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.shouldLogoDisplay,
                      expression: "shouldLogoDisplay"
                    }
                  ],
                  staticClass: "liliSmallLogo",
                  attrs: { center: "", src: "/static/logo-1@3x.png" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-col", { attrs: { cols: "2", "align-self": "center" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { align: "center", justify: "start" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-progress-linear", {
                attrs: { "background-color": "#e7e7e8", color: "#35d6ed" },
                model: {
                  value: _vm.progressPercent,
                  callback: function($$v) {
                    _vm.progressPercent = $$v
                  },
                  expression: "progressPercent"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-724f63b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-724f63b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/template/templateDesktop.vue
// module id = null
// module chunks = 